export interface ChatRequestContext {
  url?: string | null;
  context?: string | null;
}

export function hasChatRequestContext(
  requestContext?: ChatRequestContext | null
): requestContext is ChatRequestContext {
  return !!requestContext?.url?.trim() || !!requestContext?.context?.trim();
}
